import { useEffect, useState } from "react";
import { useApp } from "../App";
import { useBooksLanguage } from "./booksLanguage";
import api from "../api";
export default function AccountingOverview() {
  const {
    currentCompany,
    setPage
  } = useApp();
  const t = useBooksLanguage();
  const [state, setState] = useState({});
  const id = currentCompany?.id;
  useEffect(() => {
    if (!id) return;
    const c = new AbortController();
    api.get(`/books/${encodeURIComponent(id)}/overview`, {
      signal: c.signal
    }).then(({
      data
    }) => {
      if (!c.signal.aborted) setState({
        id,
        data
      });
    }).catch(() => {
      if (!c.signal.aborted) setState({
        id,
        error: true
      });
    });
    return () => c.abort();
  }, [id]);
  const s = state.id === id ? state : {};
  return <section className="page"><h1>{t("Бухгалтерская сводка", "Przegląd księgowy")}</h1>{!id ? <p>{t("Выберите фирму выше.", "Wybierz firmę powyżej.")}</p> : <><p className="accounting-muted">{t("Документы, проводки и оплаты — отдельные реестры.", "Dokumenty, dekrety i rozliczenia to oddzielne rejestry.")}</p>{s.error ? <p role="alert">{t("Не удалось загрузить сводку. Откройте книги или повторите выбор компании.", "Nie udało się pobrać przeglądu. Otwórz księgi lub ponownie wybierz firmę.")}</p> : !s.data ? <p>{t("Загрузка…", "Ładowanie…")}</p> : <div className="accounting-summary">{[["documents", "Документы", "Dokumenty"], ["journal_entries", "Записи журнала", "Zapisy dziennika"], ["bank_transactions", "Банковские операции", "Operacje bankowe"], ["bank_needs_review", "Банк: требует проверки", "Bank: do weryfikacji"]].map(([k, ru, pl]) => <div key={k}><span>{t(ru, pl)}</span><strong>{s.data.counts?.[k] ?? "—"}</strong></div>)}</div>}</>}
<h2>{t("Работа с документами", "Praca z dokumentami")}</h2><div className="accounting-shortcuts">{[["company_books", "Книги и сверка", "Księgi i uzgodnienia"], ["owner_invoices", "Реестр фактур", "Rejestr faktur"], ["counterparties", "Контрагенты", "Kontrahenci"], ["bank_accounts", "Банковские счета", "Rachunki bankowe"], ["hr_employees", "Кадры и зарплата", "Kadry i płace"], ["my_taxes", "Налоги и декларации", "Podatki i deklaracje"], ["documents", "Документы и подписи", "Dokumenty i podpisy"]].map(([p, ru, pl]) => <button key={p} onClick={() => setPage(p)}>{t(ru, pl)} →</button>)}</div><p className="accounting-note">{t("Рабочие отчёты и файлы JPK требуют проверки. Отправка в налоговую и KSeF — отдельные действия.", "Raporty robocze i pliki JPK wymagają kontroli księgowej. Wysyłka do urzędu i KSeF to odrębne czynności.")}</p></section>;
}
